import React from "react";
import "./Spinner.css";

export const Spinner = () => (
    <p>Loading...</p>
);

export default Spinner;